module.exports = __webpack_public_path__ + "static/media/10.fb26ff7b.jpg";